import React from 'react'
import * as PropTypes from 'prop-types'
import { Form, Input } from 'antd'
import { useTranslation } from 'react-i18next'

const NameField = ({
  onChange,
  required = false,
  label,
  min = 4,
  max = 100,
  autoFocus = false,
  fieldName = 'name',
  autoComplete = 'name',
  formName,
  extra,
  disabled,
  addonAfter,
  onBlur,
  placeholder
}) => {
  const { t } = useTranslation()

  return (
    <Form.Item
      label={label || t('common.name')}
      name={fieldName}
      extra={extra}
      rules={[
        {
          required,
          message: t('common.nameRequired'),
          whitespace: true
        },
        { max, message: t('auth.nameLong') },
        { min, message: t('auth.nameLength') }
      ]}
    >
      <Input
        disabled={disabled}
        data-testid={`${formName || 'nameField'}-${fieldName}`}
        onChange={onChange}
        autoFocus={autoFocus}
        autoComplete={autoComplete}
        maxLength={max}
        onBlur={onBlur}
        addonAfter={addonAfter}
        dir="auto"
        placeholder={placeholder}
      />
    </Form.Item>
  )
}

NameField.propTypes = {
  required: PropTypes.bool,
  label: PropTypes.string,
  min: PropTypes.number,
  autoFocus: PropTypes.bool,
  onChange: PropTypes.func,
  fieldName: PropTypes.any,
  addonAfter: PropTypes.any,
  onBlur: PropTypes.func,
  autoComplete: PropTypes.string,
  placeholder: PropTypes.string
}

export default NameField
